// Returns single image data object for gatsby images. Expects array of data from graphql quesry and name of image (no filetype)
export const findImage = (data, imageName) => {
  const filteredImage = data.allFile.edges.filter(ele => { return ele.node.name === imageName; });
  return filteredImage[0].node.childImageSharp.gatsbyImageData;
};